import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from "i18next";
import Widget from "@components/Widget/Widget";
import WeatherStatus from "@features/Weather/components/WeatherStatus";
import WeatherTable from "@features/Weather/components/WeatherTable";
import "./BigScreenWeatherWidget.scss";
import { useIataContext } from "@contexts/IataContext";
export const BigScreenWeatherWidget = () => {
    const { iata } = useIataContext();
    return (_jsx(Widget.Container, { children: _jsx(Widget.Body, { children: _jsxs("div", { className: "WeatherWidget-content", children: [_jsx("h3", { className: "widget__title", children: t("weather.widgets.dailyWeather.title", { location: t(`airportIata.${iata.toLocaleLowerCase()}`) }) }), _jsxs("div", { className: "WeatherWidget-wrapper", children: [_jsx("div", { className: "WeatherWidget-weather-status", children: _jsx(WeatherStatus, { iata: iata }) }), _jsx(WeatherTable, { iata: iata })] })] }) }) }));
};
BigScreenWeatherWidget.displayName = "BigScreenWeatherWidget";
